const MAX_SEGMENT_CHARS = 4096;
const SEGMENT_DELIMITER = /\{bubble\}|\{\/list_message\}|\{\/reply_button\}|\{img[^}]*\}/gi;

export function findExceedingSegment(text) {
  return text
    .split(SEGMENT_DELIMITER)
    .findIndex((seg) => seg.length > MAX_SEGMENT_CHARS);
}

export function hasSegmentErrors(intent) {
  const hasResponseError = intent.responses.some((response) =>
    response.split(SEGMENT_DELIMITER).some((seg) => seg.length > MAX_SEGMENT_CHARS),
  );

  const hasConditionalResponseError = (intent.conditional_responses || []).some(
    (conditional) =>
      typeof conditional.response === "string" &&
      conditional.response.split(SEGMENT_DELIMITER).some((seg) => seg.length > MAX_SEGMENT_CHARS),
  );

  return hasResponseError || hasConditionalResponseError;
}
